var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCancelIcon = function SvgCancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "second-button-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A10.01 10.01 0 0 0 10 0Zm0 1.333A8.667 8.667 0 1 1 1.333 10 8.656 8.656 0 0 1 10 1.333ZM6.146 5.548a.667.667 0 0 0-.4 1.139L9.051 10l-3.305 3.305a.667.667 0 1 0 .944.938l3.305-3.305 3.305 3.305a.667.667 0 1 0 .944-.937l-3.305-3.305 3.305-3.312a.665.665 0 1 0-.944-.937L9.995 9.057 6.69 5.752a.667.667 0 0 0-.544-.203Z"
  })));
};
export default SvgCancelIcon;